export default "__VITE_ASSET__eb0yiFb2__"